import { NavLink, Outlet } from 'react-router-dom';

const SECTIONS = [
  { to: '/admin/plans', label: 'Plans' },
  { to: '/admin/categories', label: 'Categories' },
  { to: '/admin/phrases', label: 'Phrases' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/payments', label: 'Payments' },
  { to: '/admin/email', label: 'Email' },
  { to: '/admin/support-categories', label: 'Support categories' },
];

export function AdminLayout() {
  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <h2>Admin</h2>
        <nav>
          {SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              className={({ isActive }) => `admin-nav-link${isActive ? ' is-active' : ''}`}
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}
